import React, { useState } from 'react';
import { shape, func } from 'prop-types';

import { InfoDrawer } from './InfoDrawer';
import { BundleImage } from './BundleImage';
import { getGridClasses } from '../utils/ui';
import { getBundleImage } from '../utils/product-utils';
import ProductPodLayout from './laundry/ProductPodLayout';
import LaundryContainerTitle from './LaundryContainerTitle';
import { ACCESSORIES, LAUNDRY_GRID_BASE } from '../constants/index';
import { LaundryProductDetails } from './laundry/LaundryProductDetails';

const AccessoriesContainer = ({
  product,
  onSwapVariant
}) => {
  const { category, identifiers } = product || {};
  const { productLabel } = identifiers || {};
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const handleChange = (value) => {
    onSwapVariant({
      category,
      itemId: value
    });
  };

  const handleDrawer = (isOpen) => {
    setIsDrawerOpen(isOpen);
  };

  const gridClasses = getGridClasses({
    md: 4,
    lg: 2
  });
  return (
    <>
      <div
        data-testid="accessories-container"
        className={`sui-px-3 md:sui-px-0 md:sui-grid ${LAUNDRY_GRID_BASE} ${gridClasses}`}
      >
        <div className="sui-hidden md:sui-block sui-py-1 md:sui-col-span-4 lg:sui-col-span-2">
          <LaundryContainerTitle text="Storage & Stacking Accessories" onInfoClick={() => handleDrawer(true)} />
        </div>
        <div className="sui-py-4 md:sui-col-span-3 lg:sui-col-span-2">
          <ProductPodLayout
            leftColumn={(
              <BundleImage src={getBundleImage(product, 2)} alt={productLabel} />
            )}
            rightColumn={(
              <div className="sui-flex sui-flex-col sui-items-start sui-gap-3">
                <div className="md:sui-hidden">
                  <LaundryContainerTitle
                    text="Storage & Stacking Accessories"
                    wrap
                    onInfoClick={() => handleDrawer(true)}
                  />
                </div>
                <LaundryProductDetails product={product} onSwapVariant={handleChange} />
              </div>
            )}
          />
        </div>
      </div>
      <InfoDrawer type={ACCESSORIES} isOpen={isDrawerOpen} onClose={() => handleDrawer(false)} />
    </>
  );
};

AccessoriesContainer.propTypes = {
  product: shape({}),
  onSwapVariant: func.isRequired
};

AccessoriesContainer.defaultProps = {
  product: null
};

AccessoriesContainer.dataModel = LaundryProductDetails.dataModel;

export default AccessoriesContainer;